module.exports = __webpack_public_path__ + "img/scene2-18.a4d19633.jpg";